<template>
<!-- Start Aboutus Parallex -->
<section class="section about-parallex">

    <div class="container">
        <h3 class="text-white text-center steps-heading">Six (6) Steps to Complete Our Assessments</h3><br><br><br>
        <div class="row">
            <div class="col-lg-4 col-sm-6">
                
                <div class="about-feature-main mt-lg-0 mt-5 d-flex justify-content-start">
                     
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">1 </h4>
                         <span class="icon mdi mdi-send-circle-outline d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Request Information</h4>
                        <p class="text-white mb-0 features-info">Send a request to us and we will reach out to you about any assessment you would like to do.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="about-feature-main mt-lg-0 mt-5 d-flex justify-content-start">
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">2</h4>
                          <span class="icon mdi mdi-phone-outline d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Engage with our Sales Team  </h4>
                        <p class="text-white mb-0 features-info">Our sales team will communicate with you as soon as possible to inform you about the product you are interested in </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="about-feature-main mt-lg-0 mt-5 d-flex justify-content-start">
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">3</h4>
                          <span class="icon mdi mdi-email-receive d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Receive our Assessment</h4>
                        <p class="text-white mb-0 features-info">Your assessment will be sent to you via email once it has been confirmed that you are interested in doing it.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="about-feature-main mt-5 d-flex justify-content-start">
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">4</h4>
                         <span class="icon mdi mdi-cursor-default-click-outline d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Get an Assessment Link</h4>
                        <p class="text-white mb-0 features-info">You will receive a unique link from where you can start an assessment and even return to complete it in the even that you didnt't finish all at once</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="about-feature-main mt-5 d-flex justify-content-start">
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">5</h4>
                         <span class="icon mdi mdi-form-select d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Take our Assessment</h4>
                        <p class="text-white mb-0 features-info">You will be presented with a welcome screen upon starting your assessment so you will get brief description of what it entails then you can start and navigate to each module</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="about-feature-main mt-5 d-flex justify-content-start">
                    <div class="index-box mr-3 z-index">
                        <h4 class="number green-color">6</h4>
                         <span class="icon mdi mdi-finance d-flex align-items-center justify-content-center transition steps-icon">
                            </span>
                    </div>
                    <div class="about-feature-info z-index">
                        <h4 class="text-white">Obtain an Assessment Report</h4>
                        <p class="text-white mb-0 features-info">After completing you assessment you will be presented with a completion screen and you will receive a basic report. You can purchase a more detail report</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    name: "steps",
    methods: {

    },
    mounted() {

        //alert("Product type: "+this.product);
    }
}
</script>
